(() => {
  const instances = new Map();

  class SweetOrangeProduct {
    constructor(root) {
      if (!root || root.dataset.soReady === 'true') return;
      this.root = root;
      this.root.dataset.soReady = 'true';
      this.abort = new AbortController();
      this.signal = this.abort.signal;
      this.variants = [];
      try {
        this.variants = JSON.parse(root.querySelector('[data-so-variants]')?.textContent || '[]');
      } catch (error) {
        console.warn('Sweet Orange: données de variantes illisibles.', error);
      }
      this.bindTabs();
      this.bindGallery();
      this.bindVariants();
      this.updateQuote();
    }

    bindGallery() {
      this.root.querySelectorAll('[data-so-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          const id = button.dataset.soThumb;
          this.root.querySelectorAll('[data-so-media]').forEach((media) => media.classList.toggle('is-active', media.dataset.soMedia === id));
          this.root.querySelectorAll('[data-so-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', String(thumb === button)));
        }, { signal: this.signal });
      });
    }

    selectedOptions() {
      return [...this.root.querySelectorAll('[data-so-option-group]')].map((group) => {
        const checked = group.querySelector('input:checked');
        const select = group.querySelector('select');
        return (checked || select)?.value;
      }).filter(Boolean);
    }

    bindVariants() {
      this.root.querySelectorAll('[data-so-option-group] input, [data-so-option-group] select').forEach((control) => {
        control.addEventListener('change', () => this.updateVariant(), { signal: this.signal });
      });
      this.root.querySelector('[data-so-quantity]')?.addEventListener('input', () => this.updateQuote(), { signal: this.signal });
    }

    updateVariant() {
      const selected = this.selectedOptions();
      const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
      const variantInput = this.root.querySelector('[data-so-variant-id]');
      if (variantInput) variantInput.value = variant?.id || '';
      if (variant) {
        const price = this.root.querySelector('[data-so-price]');
        if (price) price.innerHTML = variant.price_html;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
      this.updateQuote();
    }

    updateQuote() {
      const link = this.root.querySelector('[data-so-quote]');
      if (!link) return;
      const url = new URL(link.dataset.baseUrl, window.location.origin);
      url.searchParams.set('product', this.root.dataset.productTitle || '');
      url.searchParams.set('product_url', window.location.href);
      url.searchParams.set('product_id', this.root.dataset.productId || '');
      const variant = this.root.querySelector('[data-so-variant-id]')?.value;
      if (variant) url.searchParams.set('variant', variant);
      this.root.querySelectorAll('[data-so-option-group]').forEach((group) => {
        const control = group.querySelector('input:checked, select');
        if (control?.value) url.searchParams.append(`option[${group.dataset.soOptionGroup}]`, control.value);
      });
      const quantity = this.root.querySelector('[data-so-quantity]')?.value;
      if (quantity) url.searchParams.set('quantity', quantity);
      const price = this.root.querySelector('[data-so-price]')?.textContent.trim();
      if (price) url.searchParams.set('price', price);
      link.href = url.toString();
    }

    bindTabs() {
      const tabs = [...this.root.querySelectorAll('[role="tab"]')];
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(tabs, index), { signal: this.signal });
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = index;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          this.selectTab(tabs, target);
          tabs[target].focus();
        }, { signal: this.signal });
      });
    }

    selectTab(tabs, index) {
      tabs.forEach((tab, current) => {
        const active = current === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    }

    destroy() {
      this.abort.abort();
      delete this.root.dataset.soReady;
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-so-product]').forEach((root) => {
      const instance = new SweetOrangeProduct(root);
      instances.set(root.id, instance);
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-so-product]').forEach((root) => {
      instances.get(root.id)?.destroy();
      instances.delete(root.id);
    });
  });
})();
